import { toNozzleDirectionText } from "@/common/filter"
import { NozzleRecord } from "@/components/FlowSheetEditor/services/modal"
import { DeleteOutlined, EditOutlined } from "@ant-design/icons"
import { Space, Popconfirm, Button, Modal, Form, InputNumber, Row, Input } from "antd"
import { Node } from "@antv/x6"
import { useState } from "react"

export interface EditableNozzleTableProps {
  nozzles: NozzleRecord[]
  node: Node
  onChange: () => void
  deleteAble?: boolean
}

export const EditableNozzleTable = (props: EditableNozzleTableProps) => {
  const {nozzles, node, onChange, deleteAble = true} = props;
  const [form] = Form.useForm()
  const [edit, setEdit] = useState<NozzleRecord | null>(null)

  const delConfirm = (item) => {
    node.removePort(item.id)
    onChange()
  }

  const onEdit = (item: NozzleRecord) => {
    setEdit(item)
    form.setFieldsValue({
      name: item.name,
      x: item.layout?.x || 0,
      y: item.layout?.y || 0
    })
  }

  const cancelEdit = () => {
    form.setFieldsValue({})
    setEdit(null)
  }

  const onSave = (values) => {
    const {name, x, y} = values;
    const port = node.getPort(edit!.id)
    if (port) {
      port.data.name = name;
      port.data.layout.x = x;
      port.data.layout.y = y;
      node.setPortProp(edit!.id, 'data', port.data)
      node.setPortProp(edit!.id, 'args', {x, y})
    }
    onChange()
    cancelEdit()
  }

  return <><table className="bordered-table">
    <thead>
      <tr>
        <td>Name</td>
        <td>Direction</td>
        <td>X</td>
        <td>Y</td>
        <td>Action</td>
      </tr>
    </thead>
    <tbody>
      {nozzles.map(item => {
        return <tr key={item.id}>
          <td>{item.name}</td>
          <td>{toNozzleDirectionText(item.direction!)}</td>
          <td>{item.layout?.x}</td>
          <td>{item.layout?.y}</td>
          <td>
            <Space>
              {deleteAble && <Popconfirm
                title="Delete nozzle"
                description={`Are you sure to delete the ${item.name}?`}
                onConfirm={() => delConfirm(item)}
                okText="Yes"
                cancelText="No"
              >
                <Button icon={<DeleteOutlined />} danger />
              </Popconfirm>}
              <Button icon={<EditOutlined />} onClick={() => onEdit(item)} />
            </Space>
          </td>
        </tr>
      })}
    </tbody>

  </table>
  <Modal
    {...props}
    width={600}
    open={!!edit}
    onCancel={cancelEdit}
    okText="Save"
    onOk={() => form.submit()}
  >
    <div>Edit Nozzle</div>
    <Form
      form={form}
      onFinish={(values) => {
        onSave(values)
      }}
      className="mt-4"
    >
      <Form.Item
          name='name'
          label='Group Name'
          rules={[
            {
              required: true,
              message: 'Select a nozzle group',
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name='x'
          label='X'
          rules={[
            {
              required: true,
            },
          ]}
        >
          <InputNumber controls={false} min={-1} max={2}  />
        </Form.Item>
        <Form.Item
          name='y'
          label='Y'
          rules={[
            {
              required: true,
            },
          ]}
        >
          <InputNumber controls={false} min={-1} max={2} />
        </Form.Item>
      </Form>
    </Modal>
  </>
}